// Изменено: 2025-12-24 - Добавлена конвертация валют для отображения цен
// Изменено: 2026-07-03 - USD конвертируется в валюту локали; RUB и Tinkoff — как оплачено

import {FormattedCurrency} from './formatted-currency';
import React from 'react';
import {Price} from '../billing/price';
import {Trans} from './trans';
import clsx from 'clsx';
import {useCurrencyConverter} from './convert-currency';
import {resolveBillingDisplayMoney} from '../billing/resolve-billing-display-money';

interface FormattedPriceProps {
  price?: Omit<Price, 'id'>;
  /** Шлюз подписки (tinkoff → отображение в RUB). */
  paymentGateway?: string | null;
  variant?: 'slash' | 'separateLine';
  className?: string;
  priceClassName?: string;
  periodClassName?: string;
}
export function FormattedPrice({
  price,
  paymentGateway,
  variant = 'slash',
  className,
  priceClassName,
  periodClassName,
}: FormattedPriceProps) {
  const {localeCurrency, currencyRate} = useCurrencyConverter();

  if (!price) return null;

  const translatedInterval = <Trans message={price.interval} />;

  const amountPerPeriod = price.amount / (price.interval_count ?? 1);
  const {amount: convertedAmount, currency: convertedCurrency} =
    resolveBillingDisplayMoney({
      amount: amountPerPeriod,
      currency: price.currency,
      paymentGateway,
      localeCurrency,
      currencyRate,
    });

  return (
    <div className={clsx('flex gap-6 items-center', className)}>
      <div className={priceClassName}>
        <FormattedCurrency
          value={convertedAmount}
          currency={convertedCurrency}
        />
      </div>
      {variant === 'slash' ? (
        <div className={periodClassName}> / {translatedInterval}</div>
      ) : (
        <div className={periodClassName}>
          <Trans message="per" /> <br /> {translatedInterval}
        </div>
      )}
    </div>
  );
}
